import { useEffect } from 'react'

const META_PIXEL_ID = '1474957487774441'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

export function useMetaPixel(): void {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return
    ;(function (f: Window, b: Document, e: string, v: string) {
      const pixel = function (...args: unknown[]) {
        const pixelFunction = pixel as typeof pixel & {
          callMethod?: (...methodArgs: unknown[]) => void
          queue: unknown[][]
        }

        if (pixelFunction.callMethod) {
          pixelFunction.callMethod(...args)
        } else {
          pixelFunction.queue.push(args)
        }
      } as typeof pixel & {
        callMethod?: (...methodArgs: unknown[]) => void
        queue: unknown[][]
        push?: typeof pixel
        loaded?: boolean
        version?: string
      }

      f.fbq = pixel
      f._fbq = pixel
      pixel.push = pixel
      pixel.loaded = true
      pixel.version = '2.0'
      pixel.queue = []

      const script = b.createElement(e)
      script.async = true
      script.src = v
      b.head.appendChild(script)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    window.fbq('init', META_PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}
